import { Col, Image, Row } from 'antd'; // Suponiendo que usas Ant Design para las imágenes
import React from 'react';
import PoderE from '../../assets/img/poder_ejecutivo.png';
import PoderJ from '../../assets/img/poder_judicial.png';
import PoderL from '../../assets/img/poder_legislativo.png';

function PoderesUnion() {
  return (
    <>
    	<div style={{width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%" }}>

          <div style={{ marginTop:"50px", width: "80%", marginLeft: "10%", marginRight: "10%"}}>
            <Row style={{ color: "#D5007F", fontWeight: "bold" , fontSize:"16px"}}>
              <p>Consulta los expedientes de elegibilidad e idoneidad.</p>
            </Row>
          </div>
          <div style={{ width: "80%", marginLeft: "15%"}}>
            <Row style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Col xs={24} sm={12} md={8}>
              <a href="https://www.eleccionjudicial.adyt.gob.mx/" target="_blank" className="power-link"> 
                  <Row style={{ display: "flex", alignItems: "center", alignContent: "center"}}>
                    <Col style={{ marginRight: "8px"}}>
                      <Row>
                        <Image preview={false} alt="Poder Ejecutivo" 
                            style={{
                              width: '100%',
                              maxWidth: '250px',
                              height: 'auto',
                            }}
                            src={PoderE}
                        />
                      </Row>
                      <Row style={{ justifyContent: "center", marginTop: "10px", color:"#841476"  }}>
                        Poder Ejecutivo
                      </Row>
                    </Col>
                  </Row>
              </a>
              </Col>
              <Col xs={24} sm={12} md={8} style={{ display: "flex", alignItems: "center", alignContent: "center"}}>
              <a href="https://comiteevaluacionpjf.senado.gob.mx/comite/inicio" target="_blank" className="power-link"> 
                  <Row style={{ display: "flex", alignItems: "center", alignContent: "center"}}>
                    <Col style={{ marginRight: "8px"}}>
                      <Row>
                        <Image preview={false} alt="Poder Legislativo"
                              style={{
                                width: '100%',
                                maxWidth: '250px',
                                height: 'auto',
                                }}
                          src={PoderL}
                        />
                      </Row>
                      <Row style={{ justifyContent: "center", marginTop: "10px", color:"#841476"  }}>
                        Poder Legislativo
                      </Row>
                    </Col>
                  </Row> 
                </a>
              </Col>
              <Col xs={24} sm={12} md={8} style={{ display: "flex", alignItems: "center", alignContent: "center"}}>
                <a href="https://comiteevaluacion.scjn.gob.mx/" target="_blank" className="power-link"> 
                <Row style={{ display: "flex", alignItems: "center", alignContent: "center"}}>
                    <Col style={{ marginRight: "8px"}}>
                      <Row>
                        <Image preview={false} alt="Poder Judicial"
                              style={{
                                width: '100%',
                                maxWidth: '250px',
                                height: 'auto',
                                }}
                          src={PoderJ}
                        />
                      </Row>
                      <Row style={{ justifyContent: "center", marginTop: "10px", color:"#841476" }}>
                        Poder Judicial
                      </Row>
                    </Col>
                  </Row> 
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default PoderesUnion;